<template>
    <v-dialog
        v-model="isOpen"
        max-width="400px"
        persistent
        elevation="24">
        <v-card>
            <v-card-title class="headline red" :class="titleClass">
                <v-icon class="mr-1" size="30" :color="iconColor">{{ icon }}</v-icon>
              {{ title }}
            </v-card-title>
            <v-card-text>
                <p>{{ message }}</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    class="text-none"
                    size="small"
                    variant="flat"
                    color="primary"
                    @click="closeDialog">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        message: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: "success", // Valores possíveis: "success" ou "error"
        },
    },
    data() {
        return {
            isOpen: this.dialog, // Variável local para o estado do modal
        };
    },
    watch: {
        dialog(val) {
            this.isOpen = val; // Sincroniza o valor da prop com o estado local
        },
        isOpen(val) {
            this.$emit("update:dialog", val); // Emite o evento para atualizar o pai
        },
    },
    computed: {
        icon() {
            return this.type === "success" ? "mdi-check-circle" : "mdi-alert-circle";
        },
        iconColor() {
            return this.type === "success" ? "green" : "red";
        },
        titleClass() {
            return this.type === "success" ? "text-success" : "text-error";
        },
    },
    methods: {
        closeDialog() {
            this.isOpen = false; // Fecha o modal
        },
    },
};
</script>

<style scoped>
.text-success {
    color: green;
}

.text-error {
    color: red;
}
</style>
